import { ECounterType, VoucherType } from "@tm/models"

export type VoucherRouteParams = {
    type?: string
    id?: string
    workTaskId?: string
}

export function getCounterType(identifier: VoucherType) {
    switch (identifier) {
        case VoucherType.CostEstimation:
            return ECounterType.VoucherCostEstimate
        case VoucherType.Order:
            return ECounterType.VoucherOrders
        default:
            return ECounterType.Undefined
    }
}
